import { addRTSliceReducer } from './addRT.slice';
import { ADD_RT_SLICE_NAME } from './addRT.const';

export const addRTSliceConfigCombineReducer = {
  name: ADD_RT_SLICE_NAME,
  reducer: addRTSliceReducer,
};
